const Blog = () => {
  return (
    <section className='py-32 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='section-title'>
          Блог
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          Читайте наши последние статьи и обновления о технологиях и инновациях.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Технологические тренды</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Узнайте о новейших тенденциях в мире технологий.
            </p>
          </div>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Истории успеха</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Истории наших клиентов и их достижений.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
